<div class="paginator">
  @if (this.showFirstLastButtons) {
    <button title="previous" class="navigation-button" (click)="this.previous()">
      <img alt="arrow-left" src="assets/assignments/angle-circle-left.svg" />
    </button>
  }
  <div class="ellipse-container">
    @for (page of [].constructor(this.getNumberOfPages()); track page; let i = $index) {
      <div class="ellipse"
      [class.selected]="i === this.pageIndex"></div>
    }
  </div>
  @if (this.showFirstLastButtons) {
    <button title="next" class="navigation-button" (click)="this.next()">
      <img alt="arrow-right" src="assets/assignments/angle-circle-right.svg" />
    </button>
  }
</div>